const actions = {
  FETCH_NPS_ADMIN_DATA: 'FETCH_NPS_ADMIN_DATA',
  FETCH_NPS_ADMIN_DATA_SUCCESS: 'FETCH_NPS_ADMIN_DATA_SUCCESS',
  FETCH_NPS_ADMIN_DATA_ERROR: 'FETCH_NPS_ADMIN_DATA_ERROR',
  CREATE_NPS_CAMPAIGN: 'CREATE_NPS_CAMPAIGN',
  CREATE_NPS_CAMPAIGN_SUCCESS: 'CREATE_NPS_CAMPAIGN_SUCCESS',
  CREATE_NPS_CAMPAIGN_ERROR: 'CREATE_NPS_CAMPAIGN_ERROR',
  UPDATE_NPS_CAMPAIGN: 'UPDATE_NPS_CAMPAIGN',
  UPDATE_NPS_CAMPAIGN_SUCCESS: 'UPDATE_NPS_CAMPAIGN_SUCCESS',
  UPDATE_NPS_CAMPAIGN_ERROR: 'UPDATE_NPS_CAMPAIGN_ERROR',
  SET_NPS_CAMPAIGN_ACTIVE: 'SET_NPS_CAMPAIGN_ACTIVE',
  SET_NPS_CAMPAIGN_ACTIVE_SUCCESS: 'SET_NPS_CAMPAIGN_ACTIVE_SUCCESS',
  SET_NPS_CAMPAIGN_ACTIVE_ERROR: 'SET_NPS_CAMPAIGN_ACTIVE_ERROR',
  FETCH_ACTIVE_NPS: 'FETCH_ACTIVE_NPS',
  FETCH_ACTIVE_NPS_SUCCESS: 'FETCH_ACTIVE_NPS_SUCCESS',
  FETCH_ACTIVE_NPS_ERROR: 'FETCH_ACTIVE_NPS_ERROR',
  SUBMIT_NPS_RESPONSE: 'SUBMIT_NPS_RESPONSE',
  SUBMIT_NPS_RESPONSE_SUCCESS: 'SUBMIT_NPS_RESPONSE_SUCCESS',
  SUBMIT_NPS_RESPONSE_ERROR: 'SUBMIT_NPS_RESPONSE_ERROR',
  DISMISS_NPS: 'DISMISS_NPS',
  DISMISS_NPS_SUCCESS: 'DISMISS_NPS_SUCCESS',
  fetchNpsAdminData: () => ({
    type: actions.FETCH_NPS_ADMIN_DATA,
  }),
  createNpsCampaign: (campaign) => ({
    type: actions.CREATE_NPS_CAMPAIGN,
    payload: campaign,
  }),
  updateNpsCampaign: (id, campaign) => ({
    type: actions.UPDATE_NPS_CAMPAIGN,
    payload: { id, ...campaign },
  }),
  setNpsCampaignActive: (id, active) => ({
    type: actions.SET_NPS_CAMPAIGN_ACTIVE,
    payload: { id, active },
  }),
  fetchActiveNps: () => ({
    type: actions.FETCH_ACTIVE_NPS,
  }),
  submitNpsResponse: (score, comment) => ({
    type: actions.SUBMIT_NPS_RESPONSE,
    payload: { score, comment },
  }),
  dismissNps: () => ({
    type: actions.DISMISS_NPS,
  }),
};

export default actions;
